import { MqttContainer, MqttValue } from './types'
import { MqttTopic } from './topics'

export const xyToolHandlebarX: MqttValue = {
  title: 'XY-Tool Handlebar x',
  unit: 'mm',
  topic: MqttTopic.XYTOOL_HANDLEBAR_X,
}

export const xyToolHandlebarY: MqttValue = {
  title: 'XY-Tool Handlebar y',
  unit: 'mm',
  topic: MqttTopic.XYTOOL_HANDLEBAR_Y,
}

export const xyToolPositionX: MqttValue = {
  title: 'XY-Tool Position x',
  unit: 'mm',
  topic: MqttTopic.XYTOOL_POSITION_X,
}

export const xyToolPositionY: MqttValue = {
  title: 'XY-Tool Position y',
  unit: 'mm',
  topic: MqttTopic.XYTOOL_POSITION_Y,
}

export const xyToolSaddleX: MqttValue = {
  title: 'XY-Tool Saddle x',
  unit: 'mm',
  topic: MqttTopic.XYTOOL_SADDLE_X,
}

export const xyToolSaddleY: MqttValue = {
  title: 'XY-Tool Saddle y',
  unit: 'mm',
  topic: MqttTopic.XYTOOL_SADDLE_Y,
}

export const xyToolBrakesX: MqttValue = {
  title: 'XY-Tool Brakes x',
  unit: 'mm',
  topic: MqttTopic.XYTOOL_BRAKES_X,
}

export const xyToolBrakesY: MqttValue = {
  title: 'XY-Tool Brakes y',
  unit: 'mm',
  topic: MqttTopic.XYTOOL_BRAKES_Y,
}

export const xyToolDefinitions: MqttContainer = {
  title: 'XY-Tool',
  prefix: 'XYtool/',
  values: [
    xyToolHandlebarX,
    xyToolHandlebarY,
    xyToolPositionX,
    xyToolPositionY,
    xyToolSaddleX,
    xyToolSaddleY,
    xyToolBrakesX,
    xyToolBrakesY,
  ],
}

export default xyToolDefinitions
